import styles from './index.module.sass';
import closeSvg from '@@/offer/images/close.svg';

export const TagFilter = ({ label, value, onCancel }: { label: string, value: string, onCancel: () => void }) => {
    return (
        <div className={styles.root}>
            {label}
            <img src={closeSvg} onClick={onCancel} className={styles.close}/>
        </div>
    )
}